import { Component, forwardRef } from "@angular/core";
import { StartAction } from "../../../../Model/Dto/StartAction";
import { TranslateService } from "@ngx-translate/core";
import { UserActionBaseComponent } from "../userAction-base.component";
import { ModelService } from "app/Services/model.service";
import { lastValueFrom } from "rxjs";
import { LoginService } from "app/Services/login.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { JobService } from "app/Services/job.service";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";

@Component({
    selector: 'useraction-flatten-category-tree',
    templateUrl: './useraction-flatten-category-tree.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UseractionFlattenCategoryTreeComponent) }
    ],
    standalone: false
})
export class UseractionFlattenCategoryTreeComponent extends UserActionBaseComponent {
  deleteLastCategory: boolean = false;
  
  constructor(public loginService: LoginService, public macroService: MacroService, public jobService: JobService, public translate: TranslateService, public catalogService: CatalogService) {
    super(loginService, macroService);
  }

  public createParameterStringAsJsonString(): string {
    return  JSON.stringify({
      deleteLastCategory: this.deleteLastCategory
    });
  }
  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.deleteLastCategory = parsed.deleteLastCategory;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
